import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "react-modal";
import Swal from "sweetalert2";
import { FaUsersCog, FaFileSignature } from "react-icons/fa";
import { Demande } from "../../models/demandeAdmin";
import { UserModel } from "../../models/UserModel";
import { getAllDemande, validateDemande, rejectDemande } from "../../services/demande_service";
import { getAllClientByUsers } from "../../services/Login_service";
import DetailDemande from "./DetailDemande";
import ButtonCustom from "../../utils/custom-button";
import { getUsersWithOtherProfession } from "../../services/User_service";
import "../../page/style/style.css";
import UserValidationModal from "./UserVallidationModal";
import { safeParseContent } from "../../utils/functions/safeParseContent";

function AdminTabs() {
  const [activeTab, setActiveTab] = useState<"demandes" | "inscriptions">("demandes");
  const [demandes, setDemandes] = useState<Demande[]>([]);
  const [selectedDemande, setSelectedDemande] = useState<Demande | null>(null);
  const [selectedUser, setSelectedUser] = useState<UserModel | null>(null);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [clients, setClients] = useState<UserModel[]>([]);
  const [users, setUsers] = useState<UserModel[]>([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const [modalUserIsOpen, setModalUserIsOpen] = useState(false);
  const [selectedUserForValidation, setSelectedUserForValidation] = useState<UserModel | null>(null);

  const openUserModal = (user: UserModel) => {
    setSelectedUserForValidation(user);
    setModalUserIsOpen(true);
  };

  const closeUserModal = () => {
    setSelectedUserForValidation(null);
    setModalUserIsOpen(false);
  };

  useEffect(() => {
    fetchClients();
    fetchDemandes();
    fetchUsers()
  }, []);
// useEffect(() => {
//   const loadData = async () => {
//     try {
//       const userId = Number(localStorage.getItem("userId"));
//       console.log("User ID depuis localStorage :", userId);

//       const [cls, dem] = await Promise.all([
//         getAllClientByUsers(userId),
//         getAllDemande(),
//       ]);

//       console.log("Réponse getAllClientByUsers :", cls);
//       console.log("Réponse getAllDemande :", dem);

//       setClients(cls || []);
      
//       const normalizedDemandes = (dem || []).map(d => {
//         const contentParsed = safeParseContent(d.content);
//         console.log("Demande ID :", d.id, "contenu parsé :", contentParsed);
//         return { ...d, content: contentParsed };
//       });

//       setDemandes(normalizedDemandes);

//     } catch (error) {
//       console.error("Erreur chargement clients et demandes", error);
//       toast.error("Erreur lors du chargement des demandes et clients");
//     }
//   };

//   loadData();
// }, []);


  useEffect(() => {
    if (activeTab === "demandes") fetchDemandes();
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "inscriptions") fetchUsers();
  }, [activeTab]);

const fetchClients = async () => {
  const userIdStr = localStorage.getItem("userId");
  if (!userIdStr) return console.error("User ID introuvable dans le localStorage");

  const userId = Number(userIdStr);

  try {
    const clientsList = await getAllClientByUsers(userId);
    // console.log("Clients récupérés :", clientsList);

    setClients(clientsList);
  } catch (error) {
    console.error("Erreur récupération clients", error);
  }
};





const fetchDemandes = async () => {
  try {
    const result = await getAllDemande();
    // console.log("Demandes brutes récupérées :", result); 

const normalized = result.map(d => {
  let contentObj;
  try {
    contentObj = JSON.parse(d.content); // parse direct
  } catch (err) {
    console.error("Erreur parsing content pour demande ID :", d.id, d.content);
    contentObj = {};
  }
  // console.log("Contenu normalisé pour demande ID :", d.id, contentObj);
  return { ...d, content: contentObj };
});

    // console.log("Demandes normalisées :", normalized);
    setDemandes(normalized);
  } catch (error) {
    console.error("Erreur lors du chargement des demandes", error);
    toast.error("Erreur lors du chargement des demandes");
  }
};


  const openModal = (demande: Demande) => {
    setSelectedDemande(demande);
    const user = clients.find(c => c.id === demande.user_id) || null;
    setSelectedUser(demande.user);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedDemande(null);
    setSelectedUser(null);
  };

  const valideDemande = async () => {
    if (!selectedDemande) return;
    setIsProcessing(true);
    try {
      const content = safeParseContent(selectedDemande.content);
      const isProfessional =
        (selectedDemande.typeDemande && selectedDemande.typeDemande.toUpperCase() === "PROFESSIONAL") ||
        content.request_type === "professional" ||
        content.request_type === "professional_account";

      const confirm = await Swal.fire({
        title: isProfessional ? "Valider demande professionnelle ?" : "Valider la demande ?",
        text: isProfessional
          ? "La validation marquera ce compte comme professionnel et utilisera les documents fournis."
          : "Confirmer la validation de la demande.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Valider",
        cancelButtonText: "Annuler",
        confirmButtonColor: "#2A919D",
      });

      if (!confirm.isConfirmed) {
        setIsProcessing(false);
        return;
      }

      await validateDemande(selectedDemande.id);
      console.log(" les données sont devenus comme ca apres validation:", selectedDemande);
      
      closeModal();
      Swal.fire({ title: "Demande validée", icon: "success", timer: 2000 });
      await fetchDemandes();
      await fetchClients();
    } catch (err: any) {
      console.error(err);
      Swal.fire({
        title: "Erreur",
        icon: "error",
        text: err?.response?.data?.message || err?.message || "Erreur lors de la validation",
      });
    } finally {
      setIsProcessing(false);
    }
  };

  const rejeterDemande = async () => {
    if (!selectedDemande) return;
    const { value: reason } = await Swal.fire({
      title: "Motif du rejet",
      input: "textarea",
      inputPlaceholder: "Expliquez pourquoi vous rejetez la demande...",
      showCancelButton: true,
      confirmButtonText: "Envoyer le rejet",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#E76F51",
    });
    if (!reason) return;
    setIsProcessing(true);
    try {
      await rejectDemande(selectedDemande.id, reason);
      closeModal();
      Swal.fire({ title: "Demande rejetée", icon: "success", timer: 2000 });
      await fetchDemandes();
      await fetchClients();
    } catch (err: any) {
      console.error(err);
      Swal.fire({
        title: "Erreur",
        icon: "error",
        text: err?.response?.data?.message || err?.message || "Erreur lors du rejet",
      });
    } finally {
      setIsProcessing(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const allUsers = await getUsersWithOtherProfession();
      // console.log("USERS FETCH",allUsers);
      setUsers(allUsers || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des utilisateurs");
    }
  };

  const nbDemandesNonValidees = demandes.filter(d => d.status === 0).length;
  const nbInscriptions = users.length;

  return (
    <div >
      {/* Onglets style Bootstrap */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item position-relative">
          <a
            className={`nav-link ${activeTab === "demandes" ? "active" : ""}`}
            onClick={() => setActiveTab("demandes")}
            role="button"
            style={{ position: "relative" }}
          >
            {nbDemandesNonValidees > 0 && (
              <span
                className="badge bg-danger me-2"
                style={{
                  borderRadius: "50%",
                  fontSize: "0.8rem",
                  position: "absolute",
                  top: "5px",
                  left: "-5px",
                  transform: "translateX(-50%)",
                }}
              >
                {nbDemandesNonValidees}
              </span>
            )}
            <FaFileSignature className="ms-2 me-2" /> Gestion des demandes
          </a>
        </li>
        <li className="nav-item position-relative">
          <a
            className={`nav-link ${activeTab === "inscriptions" ? "active" : ""}`}
            onClick={() => setActiveTab("inscriptions")}
            role="button"
            style={{ position: "relative" }}
          >
            <FaUsersCog className="me-2" /> Gestion d'inscriptions
            {nbInscriptions > 0 && (
              <span
                className="badge bg-danger ms-2"
                style={{
                  borderRadius: "50%",
                  fontSize: "0.8rem",
                  position: "absolute",
                  top: "2px",
                  right: "-10px",
                }}
              >
                {nbInscriptions}
              </span>
            )}
          </a>
        </li>
      </ul>

      {/* Contenu tab : Demandes */}
      {activeTab === "demandes" && (
        <div className="table-responsive" id="right_panel">
          <table className="table wrap-table">
            <thead>
              <tr>
                <th>Client</th>
                <th>Référence</th>
                <th>Type</th>
                <th>User ID</th>
                <th>Date de demande</th>
                <th></th>
              </tr>
            </thead>
<tbody>
  {demandes.filter(d => d.status === 0).length > 0 ? (
    demandes
      .filter(d => d.status === 0)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .map(demande => {
        const user = demande.user; 

        const civility =
          user?.civility?.toLowerCase() === "monsieur" ? "Mr." : "Mme";

        const clientName = user
          ? `${civility} ${user.firstname} ${user.name}`.trim()
          : "—";

        const content = safeParseContent(demande.content);
        const isProfessionalRequest =
          (demande.typeDemande && demande.typeDemande.toUpperCase() === "PROFESSIONAL") ||
          content.request_type === "professional" ||
          content.request_type === "professional_account";

        return (
          <tr key={demande.id}>
            <td>{clientName}</td>
            <td>{demande.reference}</td>
            <td>
              {isProfessionalRequest ? (
                <span className="badge bg-info">PROFESSIONNEL</span>
              ) : (
                demande.typeDemande || "modif"
              )}
            </td>
            <td>{demande.user_id}</td>
            <td>{new Date(demande.createdAt).toLocaleDateString()}</td>
            <td>
              <button
                type="button"
                className="user__edit"
                style={{ backgroundColor: "#F4A261" }}
                onClick={() => openModal(demande)}
              >
                Détail
              </button>
            </td>
          </tr>
        );
      })
  ) : (
    <tr>
      <td colSpan={6}>Aucune demande trouvée</td>
    </tr>
  )}
</tbody>


          </table>
        </div>
      )}

      {activeTab === "inscriptions" && (
        <div className="table-responsive" id="right_panel" style={{ overflowX: 'auto', overflowY: 'auto', maxWidth: '100vw', maxHeight: '60vh' }}>
          <table className="table wrap-table text-align-center justify-content-center">
            <thead>
              <tr>
                <th style={{ backgroundColor: "#4BB0C0", color: "white", position: "sticky", top: 0, textAlign: "center"}}>Nom & Prénom(s)</th>
                <th style={{ backgroundColor: "#4BB0C0", color: "white", position: "sticky", top: 0, textAlign: "center" }}>Email</th>
                <th style={{ backgroundColor: "#4BB0C0", color: "white", position: "sticky", top: 0, textAlign: "center" }}>Profession</th>
                <th style={{ backgroundColor: "#4BB0C0", color: "white", position: "sticky", top: 0, textAlign: "center" }}>Type</th>
                <th style={{ backgroundColor: "#4BB0C0", color: "white", position: "sticky", top: 0, textAlign: "center" }}>Date de création</th>
                <th style={{ backgroundColor: "#4BB0C0", color: "white", position: "sticky", top: 0, textAlign: "center" }}></th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users
                  .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                  .map(u => (
                  <tr key={u.id}>
                    <td className="justify-content-center text-align-center">{u.civility === 'monsieur' ? 'Mr.' : 'Mme.'} {u.name} {u.firstname}</td>
                    <td className="justify-content-center text-align-center">{u.email}</td>
                    <td className="justify-content-center text-align-center">{u.profession_is_other ? `${u.profession} (Autre)` : u.profession}</td>
                    <td className="justify-content-center text-align-center">{u.user_type == 'professionnel' ? 'Professionnel' : u.user_type == 'entreprise' ? 'Entreprise' : 'Particulier'}</td>
                    <td className="justify-content-center text-align-center">{new Date(u.createdAt).toLocaleDateString()}</td>
                    <td className="justify-content-center text-align-center">
                      <button
                        className="btn  badge"
                        onClick={() => openUserModal(u)}
                        style={{
                          background: '#4BB0C0',
                          color: 'white',
                          padding: '15px',
                        }}
                      >
                        Valider
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-align-center">Aucun utilisateur trouvé</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

{selectedDemande && selectedUser && (
  <Modal
    isOpen={modalIsOpen}
    onRequestClose={closeModal}
    contentLabel="Détails de la demande"
    style={{
      overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
      content: {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "70%",        
        maxWidth: "900px",  
        height: "100vh",      
        overflowY: "auto",  
        padding: "20px 40px", 
        borderRadius: "10px",
        backgroundColor: "#f8f9fa"
      }
    }}
  >
    <DetailDemande demande={selectedDemande} user={selectedUser} />
    <div className="button-container mt-3 text-center">
      {selectedDemande.status === 0 && (
        <>
          <ButtonCustom title="Valider" color="#2A919D" onClick={valideDemande} />
          <ButtonCustom title="Rejeter" color="#E76F51" onClick={rejeterDemande} />
        </>
      )}
      <ButtonCustom title="Fermer" color="#F4A261" onClick={closeModal} />
    </div>
  </Modal>
)}


      <UserValidationModal isOpen={modalUserIsOpen} user={selectedUserForValidation} onClose={closeUserModal} />
    </div>
  );
}

export default AdminTabs;
